module.exports = __webpack_public_path__ + "static/media/timnit_gebru.a5f821a3.jpg";